import React, {Component} from "react"

import id from "@irati/utils/id"

import {Seek, Wrapper} from "./styled"

interface Props {
  delay: boolean
  maxScore: number
  score: number
}

interface State {
  width: number
}

export const MAX_SCORE = 5

class Bar extends Component<Props, State> {
  static defaultProps: Pick<Props, "score" | "maxScore" | "delay"> = {
    score: 0,
    maxScore: MAX_SCORE,
    delay: false
  }

  state = {
    width: 0
  }

  render() {
    const {score, maxScore, delay, ...props} = this.props
    const idNamespace = id("Bar", props)
    const width = delay ? this.state.width : (score / maxScore) * 100
    if (delay) {
      setTimeout(() => {
        this.setState({width: (score / maxScore) * 100})
      }, 500)
    }
    return (
      <Wrapper id={idNamespace} {...props}>
        <Seek id={id("seek", idNamespace)} width={width} delay={delay} />
      </Wrapper>
    )
  }
}

export default Bar
